import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./Users'),
  (m) => m.default
);

export const NewUser = lazyLoad(
  () => import('./NewUser'),
  (m) => m.default
);
